import { BlogSection } from '@/types/blog';

export const neuronalesDilemmaSection: BlogSection = {
  id: 'neuronales-dilemma',
  title: 'Das neuronale Dilemma',
  content: `
    <p>
      Unser Gehirn ist evolutionär darauf ausgelegt, auf Bedrohungen zu reagieren. Früher das Rascheln im Gebüsch, heute ein Pop-up. Früher der Feind im Dorf, heute ein digitaler Mob in der Kommentarspalte. Das Problem ist nicht, dass wir fühlen, sondern dass wir ständig überflutet werden, ohne gelernt zu haben, mit diesen Gefühlen bewusst umzugehen. Viele Plattformen nutzen dies aus: Angst, Hass und Empörung erzeugen mehr Klicks als Nachdenklichkeit. Wir brauchen eine neue Art, mit Informationen umzugehen, die uns ins Gleichgewicht bringt, statt uns weiter zu überhitzen.
    </p>
  `
};
